import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {useHistory} from 'react-router-dom';
import * as Yup from 'yup';

import './styles.scss';
import {
  AppForm,
  AppFormField,
  AppFormSubmitButton,
} from '../../../../components/forms';
import AppErrorMessage from '../../../../components/app-error-message';
import {addToWizard, setWizard} from '../../../../store/actions';
import {strings} from '../../../../util/strings';
import {Column, Row} from '../../../../components/layout';
import Header2 from '../../../../components/headers/header2';
import {getDateInServerFormat} from '../../../../util/utility';
import {post, postWithCustomHeaders} from '../../../../api/api';
import ActivateRegistration from '../data-validation/activate-registration';
import {Icons} from '../../../../util/icons';
import colors from '../../../../util/colors';
import NewErrorMessage from '../../../../components/new-error-message';
import {
  uriCreateUser,
  uriRequestActivationCode,
} from '../../../../api/endpoints';

export interface DataValidationProps {
  onSubmit(values: any): any;
  setValid(value: boolean): void;
  nextStep(): void;
  valid: boolean;
  wizard: any;
  addToWizard(value: any): any;
  setWizard(value: any): any;
  labels: typeof strings.pt.register;
  messageLabels: typeof strings.pt.messages;
  language: string;
}

function AccountData({
  valid,
  setValid,
  wizard,
  labels,
  messageLabels,
  addToWizard,
  onSubmit,
  nextStep,
  language,
}: DataValidationProps) {
  const history = useHistory();
  const [submitting, setSubmitting] = useState(false);
  const [formikContext, setFormikContext] = useState<any>();
  const [visible, setVisible] = useState(false);
  const [viewPassword, setViewPassword] = useState(false);
  const [viewRepeatPassword, setViewRepeatPassword] = useState(false);
  const [existingEmailError, setExistingEmailError] = useState(false);
  const [generalError, setGeneralError] = useState(false);
  const [hoverErrorIcons, setHoverErrorIcons] = useState<any>({
    email: false,
    password: false,
    repeatPassword: false,
  });
  const [guid, setGuid] = useState(
    (wizard &&
      wizard.activateRegistration &&
      wizard.activateRegistration.guid) ||
      ''
  );

  const featureName = 'Register-AccountData';

  const handlePasswordIconClick = (repeat: boolean) => {
    if (repeat) {
      setViewRepeatPassword(!viewRepeatPassword);
    } else {
      setViewPassword(!viewPassword);
    }
  };

  const expression =
    /^[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  const isEmailAllowed = (email: string) =>
    expression.test(email.toLowerCase());

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required(messageLabels?.requiredField)
      .email(messageLabels.invalidEmailFormat)
      .test('email-format-invalid', labels?.emailPassword_emailError, (value) =>
        isEmailAllowed(value || '')
      ),
    password: Yup.string()
      .required(messageLabels?.requiredField)
      .matches(
        /^(?!.* )(?=.*\d)(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{12,}/,
        labels?.emailAndPassword_passwordError
      ),
    repeatPassword: Yup.string()
      .required(messageLabels?.requiredField)
      .oneOf([Yup.ref('password')], messageLabels.passwordsDontMatch),
  });

  if (!!!wizard?.insuranceValidation) {
    history.push('/');
  }

  const existingEmail = wizard?.dataValidation?.currentUser?.email || '';

  const sanitizeEmail = (mail: string) => {
    if (!mail) return '';
    const i = mail.indexOf('@');
    return i >= 0 ? mail.slice(i) : mail; // mantém só "@dominio.com"
  };

  if (!visible) {
    return (
      <Column className="account-data-container">
        <AppForm
          initialValues={{
            email: sanitizeEmail(existingEmail),
            password: '',
            repeatPassword: '',
          }}
          validationSchema={validationSchema}
          onSubmit={async (values, {validateForm}) => {
            const errors = await validateForm(values);
            if (Object.keys(errors).length > 0) return;

            setSubmitting(true);
            const aux: string = wizard.dataValidation.currentUser.phone;
            let buId: string | null = null;
            let memId: string | null = null;
            switch (wizard.dataValidation.currentUser.buId) {
              case 'noInsurance':
                break;
              case 'otherEntity':
                buId = 'Outra';
                break;
              default:
                buId = wizard.dataValidation.currentUser.buId;
                memId = wizard.dataValidation.cardNumber;
            }

            const state: string = wizard.dataValidation.state || null;

            const phoneNumber = aux
              ? aux.indexOf('+') >= 0
                ? aux?.split('+')[1]
                : aux
              : '';

            const guid = wizard.dataValidation?.currentUser?.sessionId;

            const user = {
              userName: values.email,
              password: values.password,
              fullName: wizard.insuranceValidation.name,
              email: values.email,
              phoneNumber: phoneNumber,
              nif: wizard.insuranceValidation.nif,
              doB: getDateInServerFormat(
                wizard.insuranceValidation.dateOfBirth
              ),
              cc: wizard.dataValidation.otherEntity || '',
              activationId: guid,
              sessionId: guid,
              buId: buId,
              state: !!state ? state : null,
              memId: memId,
              language: language,
            };

            if (wizard.dataValidation.selectedContact === values.email) {
              //Se o email inserido é igual ao selecionado [PARA UTILIZADORES COM CONTACTO NO RIOS] acabar o registo

              const guid = wizard.dataValidation?.currentUser?.sessionId;

              const user = {
                userName: values.email,
                password: values.password,
                fullName: wizard.insuranceValidation.name,
                email: values.email,
                phoneNumber: phoneNumber,
                nif: wizard.insuranceValidation.nif,
                doB: getDateInServerFormat(
                  wizard.insuranceValidation.dateOfBirth
                ),
                cc: wizard.dataValidation.otherEntity || '',
                activationId: guid,
                sessionId: guid,
                buId: buId,
                state: !!state ? state : null,
                memId: memId,
                language: language,
              };

              if (wizard.dataValidation.selectedContact === values.email) {
                //Se o email inserido é igual ao selecionado [PARA UTILIZADORES COM CONTACTO NO RIOS] acabar o registo

                try {
                  const tenantAlias = process.env;
                  await postWithCustomHeaders(
                    uriCreateUser(),
                    JSON.stringify(user),
                    {
                      headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        X_MYADV_API_KEY: tenantAlias,
                      },
                    }
                  )
                    .then((resp: any) => {
                      setVisible(true);
                      history.push('/registo-completo');
                    })
                    .catch((e: any) => {
                      (formikContext as any).setFieldError(
                        'email',
                        labels?.emailPassword_existingUsername
                      );
                      setVisible(false);
                    });
                } catch (e: any) {
                  if (e.status === 500) {
                    (formikContext as any).setFieldError(
                      'email',
                      labels?.emailPassword_existingUsername
                    );
                  } else {
                    setGeneralError(true);
                  }
                  setVisible(false);
                }
                setVisible(false);
              }
            } else {
              //Email inserido diferente do Selecionado (no caso de utilizadores com email no RIOS ou utilizadores sem contactos [onde o email selecionado é  ''])
              const newSelectedContact = values.email;
              const newSelectedContactType = 'EMAIL';

              //fazer a chamada a api de activation code para verificar se traz erro 404 (o email que está a tentar registar já existe em rios)
              try {
                await post(
                  uriRequestActivationCode(),
                  JSON.stringify({
                    destination: newSelectedContact,
                    nif: wizard.insuranceValidation.nif,
                    senderType: newSelectedContactType,
                    sessionId: guid,
                    name: wizard.insuranceValidation.name,
                    buId: wizard?.user?.buId,
                  }),
                  false,
                  featureName
                )
                  .then(() => {
                    addToWizard({user});
                    addToWizard({
                      dataValidation: {
                        ...wizard.dataValidation,
                        selectedContact: newSelectedContact,
                        selectedContactType: newSelectedContactType,
                      },
                    });
                    addToWizard({activateRegistration: {guid}});
                    setGuid(guid);
                    setVisible(true);
                  })
                  .catch((error) => {
                    if (error.status === 400) {
                      setExistingEmailError(true);
                    } else {
                      setGeneralError(true);
                    }
                    setVisible(false);
                  });
              } catch (e: any) {
                if (e.status === 400) {
                  setExistingEmailError(true);
                }
              }
            }

            setSubmitting(false);
          }}>
          <Column>
            <Header2 className="enter-code-header">
              {labels?.emailAndPassword_pageSubTitle}
            </Header2>
            {existingEmailError && !submitting && (
              <NewErrorMessage
                iconName={Icons.ALERT_PROBLEM}
                colorIcon={colors.alertRed}
                text={labels?.emailPassword_existingUsername}></NewErrorMessage>
            )}
            {generalError && !submitting && (
              <NewErrorMessage
                iconName={Icons.ALERT_PROBLEM}
                colorIcon={colors.alertRed}
                text={messageLabels?.general_errorMessage}></NewErrorMessage>
            )}
            <Row className="account-data-row" style={{position: 'relative'}}>
              <AppFormField
                showErrorMessage
                name="email"
                placeholder={labels?.emailAndPassword_emailPlaceholder}
                className="account-data-input-email"
              />

              {/** add your error display logic here */}
            </Row>

            <Row className="account-data-row" style={{position: 'relative'}}>
              <AppFormField
                showErrorMessage
                name="password"
                type={viewPassword ? 'text' : 'password'}
                passwordIcon
                pwdIconClass={
                  hoverErrorIcons.password
                    ? 'register-pwd-eye-hidden'
                    : 'register-pwd-eye'
                }
                handlePasswordIconClick={() => handlePasswordIconClick(false)}
                showPassword={viewPassword}
                placeholder={labels.emailAndPassword_passwordPlaceholder}
              />
            </Row>

            <Row className="account-data-row" style={{position: 'relative'}}>
              <AppFormField
                showErrorMessage
                name="repeatPassword"
                type={viewRepeatPassword ? 'text' : 'password'}
                passwordIcon
                pwdIconClass={
                  hoverErrorIcons.repeatPassword
                    ? 'register-pwd-eye-hidden'
                    : 'register-pwd-eye'
                }
                handlePasswordIconClick={() => handlePasswordIconClick(true)}
                showPassword={viewRepeatPassword}
                placeholder={labels.emailAndPassword_confirmPasswordPlaceholder}
              />
            </Row>

            <Row className="app-center">
              <AppFormSubmitButton
                title={labels?.register_beforeContinueButtonText}
                disabled={submitting}
                className="stepper-continue-button account-data-continue-button"
              />
            </Row>
          </Column>
        </AppForm>
      </Column>
    );
  } else {
    return (
      <ActivateRegistration
        setValid={setValid}
        valid={valid}
        onSubmit={onSubmit}
        nextStep={nextStep}
        messageLabels={messageLabels}
      />
    );
  }
}

const mapStateToProps = ({wizard, stringsDefault}: any) => ({
  wizard: wizard.value,
  labels: stringsDefault.value.pt.register,
  messageLabels: stringsDefault.value.pt.messages,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(AccountData)
);
